import React from 'react';
import { Link } from 'react-router-dom';
import BRAND from '../../config/brand';
import PublicSiteNav from '../PublicSiteNav';
import '../PublicLinksPage.css';

/**
 * Token-free landing shown if someone reloads after signing. The signing page
 * itself swaps its address to this path once the agreement is accepted.
 */
export default function AgreementSignedPage() {
  return (
    <div className="public-linktree-page public-service-page">
      <PublicSiteNav />
      <main className="public-linktree-shell public-service-shell public-lead-shell">
        <section className="public-service-panel public-lead-card public-lead-success">
          <Link className="public-service-logo" to="/links" aria-label="Back to planning links">
            <img src={BRAND.logoSrc} alt="Bautista Planning and Analytics" />
          </Link>
          <h1>Your agreement is signed.</h1>
          <p>
            A copy was emailed to you. To open it again, use the secure link in that email.
          </p>
        </section>
      </main>
    </div>
  );
}
